import styled from "styled-components";

export const InputContainer = styled.div`
  position: relative;
  width: 100%;

  .rangeslider {
    margin: 6px 0px;
    height: 8px;
    width: 100%;
  }

  .rangeslider__fill {
    width: 0;
    background-color: ${({ theme }) => theme.palette.card.text.primary};
  }

  .rangeslider__handle {
    background-color: ${({ theme }) => theme.palette.card.text.primary};
    border: none;
    box-shadow: none;
    width: 18px;
    height: 18px;
    &::after {
      display: none;
    }
  }
`;
